import {
  Html5QrcodeSupportedFormats,
  type Html5QrcodeCameraScanConfig,
  type Html5QrcodeFullConfig,
} from 'html5-qrcode';

export const BARCODE_FIELD_SCAN_FORMATS: Html5QrcodeSupportedFormats[] = [
  Html5QrcodeSupportedFormats.QR_CODE,
  Html5QrcodeSupportedFormats.AZTEC,
  Html5QrcodeSupportedFormats.CODABAR,
  Html5QrcodeSupportedFormats.CODE_39,
  Html5QrcodeSupportedFormats.CODE_93,
  Html5QrcodeSupportedFormats.CODE_128,
  Html5QrcodeSupportedFormats.DATA_MATRIX,
  Html5QrcodeSupportedFormats.ITF,
  Html5QrcodeSupportedFormats.EAN_13,
  Html5QrcodeSupportedFormats.EAN_8,
  Html5QrcodeSupportedFormats.PDF_417,
  Html5QrcodeSupportedFormats.UPC_A,
  Html5QrcodeSupportedFormats.UPC_E,
];

export const barcodeFieldHtml5QrcodeConfig: Html5QrcodeFullConfig = {
  verbose: false,
  formatsToSupport: BARCODE_FIELD_SCAN_FORMATS,
  useBarCodeDetectorIfSupported: false,
};

export const barcodeFieldCameraScanConfig: Html5QrcodeCameraScanConfig = {
  fps: 15,
  disableFlip: false,
  qrbox: (viewfinderWidth, viewfinderHeight) => ({
    width: Math.floor(viewfinderWidth * 0.92),
    height: Math.floor(Math.min(viewfinderHeight * 0.34, 168)),
  }),
};
